import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://www.demo-digiibuz.fr/Digii-Tools/DigiiGo';
const normalizedBaseUrl = rawBaseUrl.replace(/\/+$/, '');

const api = axios.create({
  baseURL: normalizedBaseUrl,
  timeout: 30000,
});

export default api;